// window.addEventListener('load', function() {
    // Select all submenu items
    const submenuItemsDetails = document.querySelectorAll('.open_when_hover');

    submenuItemsDetails.forEach(item => {
        // Get the parent details element
        const submenuItemSummary = item.querySelector('.header__menu-item--submenu');
        
        // Mouse enter event
        item.addEventListener('mouseenter', () => {
            item.setAttribute('open', '');
            if(submenuItemSummary){
                submenuItemSummary.setAttribute('aria-expanded', 'true');
            }
        });
        
        // Mouse leave event
        item.addEventListener('mouseleave', () => {
            item.removeAttribute('open');
            if (submenuItemSummary) {
                submenuItemSummary.setAttribute('aria-expanded', 'false');
            }
        });
    });

// });

window.addEventListener('load', function() {
  const wrapper = document.querySelector('.readmore-wrapper');
  
  // Check if wrapper exists first
  if (!wrapper) return;
  
  const wrapperText = wrapper.getAttribute('data-full-text');

  // Check if data exists
  if (!wrapperText || wrapperText === '') return;
  
  const textEl = wrapper.querySelector('.readmore-text');
  const btn = wrapper.querySelector('.readmore-btn');
  
  textEl.innerHTML = wrapper.dataset.fullText;
  
  const shortHeight = 125;
  let fullHeight = textEl.scrollHeight + 60;
  
  textEl.style.maxHeight = shortHeight + 'px';
  
  window.toggleReadMore = function () {
    if (textEl.classList.contains('expanded')) {
      textEl.style.maxHeight = shortHeight + 'px';
      btn.textContent = 'Read More';
      setTimeout(() => {
        textEl.classList.remove('expanded');
        btn.classList.remove('expanded-btn');
      }, 200);
    } else {
      textEl.classList.add('expanded');
      btn.classList.add('expanded-btn');
      textEl.style.maxHeight = fullHeight + 'px';
      btn.textContent = 'Read Less';
    }
  };
});


